import React, { useEffect } from "react";
import { IntlProvider } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { FEATURE_TOGGLE_MULTILANGUAGE } from "../config";
import { getMessagesFromLocale } from "../i18n";
import { updateFeatureFlags } from "../store/actions/features";
import Root from "./root";

const LanguageMiddleware = (props) => {

  const featureFlags = useSelector(state => state.featureFlags);
  const user = useSelector(state => state.user);

  let userLocale =
  navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.language;

  const langDict = {
    "it-IT": "IT",
    "es-ES": "ES",
    "en-US": "IT",
    "en-GB": "IT"
  };

  if (langDict[userLocale]){
    userLocale = langDict[userLocale].toLowerCase();
  }

  const userLocaleDict = {
    "it": "it-IT",
    "es": "es-ES"
  };

  const messages = getMessagesFromLocale(featureFlags.SPANISH_LANGUAGE ? "es" : (FEATURE_TOGGLE_MULTILANGUAGE === "true" ? (langDict[user?.profile?.language]?.toLowerCase() || (userLocaleDict[userLocale] ? userLocale : "it")) : "it"));

  const dispatch = useDispatch();

  useEffect(() => {
    const features = {
      SPANISH_LANGUAGE: false    
    };
    updateFeatureFlags(features, dispatch);
    if (window.__MINGO_FEATURE_HOOK__) {
      window.__MINGO_FEATURE_HOOK__(features, updatedFeatures => {
        updateFeatureFlags(updatedFeatures, dispatch);
      });
    }
  }, []);

  return <IntlProvider
    onError={() => {return null;}}
    key={featureFlags.SPANISH_LANGUAGE ? "ES" : (FEATURE_TOGGLE_MULTILANGUAGE === "true" ? (langDict[user?.profile?.language] || (userLocaleDict[userLocale] ? userLocale.toUpperCase() : "IT")) : "IT")}
    locale={featureFlags.SPANISH_LANGUAGE ? "ES" : (FEATURE_TOGGLE_MULTILANGUAGE === "true" ? (langDict[user?.profile?.language] || (userLocaleDict[userLocale] ? userLocale.toUpperCase() : "IT")) : "IT")}
    messages={messages} timeZoneName={featureFlags.SPANISH_LANGUAGE ? "es-ES" : (FEATURE_TOGGLE_MULTILANGUAGE === "true" ? (user?.profile?.language || (userLocaleDict?.[userLocale] || "it-IT")) : "it-IT")}>
    <Root />
  </IntlProvider>;
};

export default LanguageMiddleware;